import * as Components from './components/index';

export default defineNuxtPlugin(() => {
  if (process.client) {
    setTimeout(() => {
      const slide = new Components.Slide();
      slide.SlideBusiness();
    }, 500); 
  }
});